import React, { CSSProperties } from "react";

/**
 * 使用不可チャットボタンのプロパティ
 */
interface DeactiveButtonProps {
  onClick: () => void;
  isOpen?: boolean;
}

/**
 * 使用不可チャットボタンコンポーネント
 * 使用不可チャットウィンドウを開くためのフローティングボタン
 */
const DeactiveButton: React.FC<DeactiveButtonProps> = ({ onClick }) => {
  // 使用不可チャットボタンの位置
  const buttonStyles: CSSProperties = {
    position: "fixed",
    minWidth: "60px",
    minHeight: "60px",
    right: "20px",
    bottom: "30px",
    zIndex: 199999,
  };

  return (
    <button
      onClick={onClick}
      className="pathbee-deactive-chat-button bg-transparent border-0 p-0 transition-all duration-300 ease-in-out hover:scale-105 hover:brightness-110 overflow-visible"
      style={buttonStyles}
      aria-label="使用不可チャットボタン"
      type="button"
    >
      <img
        src="https://pathbee-prod.s3.ap-northeast-1.amazonaws.com/public/chatbots/default/deactive_banner.svg"
        alt="使用不可チャット"
        className="pathbee-deactive-chat-button-icon"
      />
    </button>
  );
};

export default DeactiveButton;
